export const formatSurcharge = (value: number) => {
  const formattedValue = Math.abs(value / 100).toFixed(2)

  if (value === 0) return `£${formattedValue}`

  return value < 0 ? `Save £${formattedValue}` : `+£${formattedValue}`
}
